var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bigbox scroll"},[_c('p',{staticClass:"title"},[_vm._v(" 信息监测 ")]),_c(_vm.name,{tag:"component",attrs:{"jumpData":_vm.jumpData}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }